import useStyles from "./styles";
import classNames from "classnames";

const Badge = ({ status }) => {
  const classes = useStyles({ status });

  const statusText = status === true ? "Active" :
    status === false ? "Inactive" :
      status === "on-leave" ? "On Leave" :
        status === "Deactivated" ? "Deactivated" :
          status === "virtual" ? "Virtual" :
            status === "physical" ? "Physical" :
              status === "declined" ? "Declined" :
                status === "high" ? "High" :
                  status === "medium" ? "Medium" :
                    status === "low" ? "Low" :
                      status === "closed" ? "Closed" :
                        status === "open" ? "Open" :
                          status === "scheduled" ? "Scheduled" :
                            status === "published" ? "Published" :
                              status === "draft" ? "Draft" :
                                status === "withdrawn" ? "Withdrawn" :
                                  status === "requested" ? "Leave Requested" :
                                    status === "primary" ? "Primary" :
                                      status === "secondary" ? "Secondary" :
                                        status === "leave-requested" ? "Leave Requested" :
                                          status === "expired" ? "Expired" :
                                            status === "approved" ? "Approved" :
                                              status === "paid" ? "Paid" :
                                                status === "active" ? "Active" :
                                                  status === "inactive" ? "InActive" :
                                                    status === "used" ? "Used" :
                                                      status === "revoked" ? "Revoked" :
                                                        status === "available" ? "Available" :
                                                          status === "unavailable" ? "Unavailable" :
                                                            status === "In review" ? "In Review" :
                                                              status === "automated" ? "Automated" :
                                                                status === "manual" ? "Manual" :
                                                                  status === "book" ? "Book" :
                                                                    status === "video" ? "Video" :
                                                                      status === "archived" ? "Archived" :
                                                                        status === "present-at-event" ? "Present at event" :
                                                                          status === "accepted" ? "Accepted" :
                                                                            status === "rejected" ? "Rejected" :
                                                                              status === "pending" ? "Pending" :
                                                                                status === "upcoming" ? "Upcoming" :
                                                                                  status === "completed" ? "Completed" :
                                                                                    status === "one-time" ? "One Time" :
                                                                                      status === "verified" ? "Verified" :
                                                                                        status === "unverified" ? "Unverified" :
                                                                                          status === "permanent" ? "Permanent" :
                                                                                            status === "pending-request" ? "Pending Request" :
                                                                                              status === "unpublished" ? "Unpublished" : "";

  return (
    <div className={classNames(classes.badgewrapper, classes.bg)}>{statusText}</div>
  );
};
export default Badge;
